import React from 'react';
import { Grid, CssBaseline } from '@material-ui/core';
import Display from 'pages/Consulta/Display';
import PageHeader from 'components/PageHeader';
import Form from './Form';
import { ConsultaContextProvider } from './Context';

function Certificado() {
  return (
    <div>
      <CssBaseline />
      <PageHeader title="Busca por Código de Consulta" subheading="Consulta" />
      <Grid container justify="center" alignItems="center">
        <Grid item sm={12} md={12} lg={6} style={{ maxWidth: '100%' }}>
          <ConsultaContextProvider>
            <Form />
            <Display />
          </ConsultaContextProvider>
        </Grid>
      </Grid>
    </div>
  );
}

export default Certificado;
